import * as angular from 'angular';

import ContactComponent from './contact.component.js';
import EditContactComponent from './editContact.component';

export default angular
    .module('fp:activationswizard:account:predispatch:contact', [])
    .component('awContact', ContactComponent)
    .component('awEditContact', EditContactComponent);